import { all } from "redux-saga/effects";
import getBirthdayDataSaga from "./getBirthdayData";
import getBirthdaysInMonthDataSaga from "./getBirthdaysInMonth";

export default function* birthdaySaga() {
  yield all([getBirthdayDataSaga(), getBirthdaysInMonthDataSaga()]);
}
